<template>
	<div class="info-item">
		<div style="padding-bottom: 5px;display: flex;align-items: center;">
			<el-divider direction="vertical"></el-divider>
			<span>{{title}}</span>
		</div>
		<!-- <div style="padding-bottom: 5px;">
			<el-alert description="适用于企业、个体商户、事业单位等、通过营业执照、组织机构代码等"> </el-alert>
		</div> -->
		<div class="form-box" v-if="form">
			<el-form label-width="140px" ref="form" :model="form" size="small">
				<el-descriptions :column="2" :border="true" :colon="false" size="mini">
					<el-descriptions-item labelClassName="my-descriptions-label" contentClassName="my-descriptions-content" label="主要身份">
						<span class="info-val">{{form.zySf}}</span>
					</el-descriptions-item>
					<el-descriptions-item labelClassName="my-descriptions-label" contentClassName="my-descriptions-content" label="经营性质">
						<span class="info-val">{{form.jyXz}}</span>
					</el-descriptions-item>
					<el-descriptions-item labelClassName="my-descriptions-label" contentClassName="my-descriptions-content" label="行业类型">
						<span class="info-val">{{form.hyType}}</span>
					</el-descriptions-item>
					<el-descriptions-item labelClassName="my-descriptions-label" contentClassName="my-descriptions-content" label="送货服务范围">
						<span class="info-val">{{form.shFwScope}}</span>
					</el-descriptions-item>
					<el-descriptions-item labelClassName="my-descriptions-label" contentClassName="my-descriptions-content" label="公司官网">
						<span class="info-val">{{form.gsGw}}</span>
					</el-descriptions-item>
					<el-descriptions-item labelClassName="my-descriptions-label" contentClassName="my-descriptions-content" label="公司Logo">
						<div class="info-val" style="display:flex;justify-content: center;">
							<img style="height:30px" :src="imgHost+form.gsLogoSrc" />
						</div>
					</el-descriptions-item>
					<el-descriptions-item labelClassName="my-descriptions-label" contentClassName="my-descriptions-content" label="主营品类">
						<span class="info-val">{{form.zyClass}}</span>
					</el-descriptions-item>
					<el-descriptions-item labelClassName="my-descriptions-label" contentClassName="my-descriptions-content" label="公司简介">
						<span class="info-val">{{form.gsDetail}}</span>
					</el-descriptions-item>
				</el-descriptions>
			</el-form>
		</div>
		<div v-else class="no-info-box">请补充相关信息</div>
	</div>
</template>

<script>
	import constant from '@/api/commons.js'
	export default {
		name: "ShowYwInfo",
		computed: {
			currencyInfo:function(){
				return this.$store.getters['app/currencyInfo'];
			},
		},
		props:['title','form'],
		data() {
			return {
				imgHost:process.env.VUE_APP_BASE_API,
				tableData: [],
				qyTyoes: constant.qyTyoes,
				countrys: constant.country,
				count: 0,
				fileName: '',
				zcCurrencys: [],
			};
		},
		mounted() {
			console.log(this.currencyInfo)
		},
		methods: {
		}
	};
</script>
<style scoped="scoped">
</style>
